// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_subtitle__H7wlU {
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000;
}

.styles_bottomContainer__HGmSB {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.styles_bottomContainer__HGmSB .styles_resetBtn__YyqF\\+ {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  border-radius: 4px;
  background-color: #0250ee;
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #fff;
}
.styles_bottomContainer__HGmSB .styles_resetBtn__YyqF\\+:hover {
  background-color: #0250ee;
  opacity: 0.8;
}
.styles_bottomContainer__HGmSB .styles_resetBtn__YyqF\\+:disabled {
  opacity: 0.5;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/Auth/ResetPassword/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;AAER;AADQ;EACI,yBAAA;EACA,YAAA;AAGZ;AADQ;EACI,YAAA;EACA,WAAA;AAGZ","sourcesContent":[".subtitle{\n    font-family: Poppins;\n    font-size: 16px;\n    font-weight: 500;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.5;\n    letter-spacing: normal;\n    color: #000;\n}\n\n.bottomContainer{\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    .resetBtn{\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        padding: 8px 16px;\n        border-radius: 4px;\n        background-color: #0250ee;\n        font-family: Poppins;\n        font-size: 14px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.71;\n        letter-spacing: normal;\n        color: #fff;\n        &:hover{\n            background-color: #0250ee;\n            opacity: 0.8;\n        }\n        &:disabled{\n            opacity: 0.5;\n            color: #fff;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitle": `styles_subtitle__H7wlU`,
	"bottomContainer": `styles_bottomContainer__HGmSB`,
	"resetBtn": `styles_resetBtn__YyqF+`
};
export default ___CSS_LOADER_EXPORT___;
